export default __webpack_public_path__ + "static/media/img122.a71f0be5.jpg";